const userIsLoggedIn = siteData.is_authenticated ? true : false
const wpRestNonce = siteData.wp_rest_nonce
const userAgent = window.navigator.userAgent.toLowerCase()
const isIos = /iphone|ipad|ipod/.test( userAgent )
const nativeConnection = !! window.navigator.connection

const localStore = {
	'userLocation': localStorage.getItem( 'user_location' )
}
const userLocation = localStore['userLocation'] ? JSON.parse( localStore['userLocation'] ) : false

const initialState = {
	// User:
	userIsLoggedIn,
	wpRestNonce,
	userLocation,

	// Device:
	isIos,
	screenWidth: window.innerWidth,
	screenHeight: window.innerHeight,
	isMobile: window.innerWidth <= siteData.mobile_max_width,

	// Connection:
	connection: {
		onLine: true,
		possiblySlowNetwork: false, // Guessed connection speed when nativeConnection is not available.
		downlink: nativeConnection ? navigator.connection.downlink : false, // Megabits per second.
		rtt: nativeConnection ? navigator.connection.rtt : false, // Ms.
		effectiveType: nativeConnection ? navigator.connection.effectiveType : false, // 'slow-2g', '2g', '3g', or '4g'.
	},

	// Scripts:
	loadedScripts: [],

	// DKE:
	metaData: siteData.meta ? JSON.parse( siteData.meta ) : false,
	sectionData: siteData.sections ? JSON.parse( siteData.sections ) : false,

	// Site:
	siteHasLoaded: false,
	menuIsOpen: false,
	menuItems: siteData.site_menu,
	menuItemsSecondary: siteData.site_menu_secondary,
	locationsById: {},
	locationsCloseToLocation: false
}

export default function reducer( state = initialState, action ) {
	const { payload } = action
	let locationsCloseToLocation

	switch ( action.type ) {
		case 'SET_SITE_LOADED':
			return {
				...state,
				siteHasLoaded: true
			}

		case 'ADD_SCRIPT':
			return {
				...state,
				loadedScripts: [
					...state.loadedScripts,
					payload
				]
			}

		case 'GET_SCREEN_SIZE':
			return {
				...state,
				screenWidth: window.innerWidth,
				screenHeight: window.innerHeight,
				isMobile: window.innerWidth <= siteData.mobile_max_width
			}

		case 'SET_ONLINE_STATUS':
			return {
				...state,
				connection: {
					...state.connection,
					onLine: payload
				}
			}

		case 'SET_CONNECTION_STATUS':
			return {
				...state,
				connection: {
					...state.connection,
					...payload
				}
			}

		case 'OPEN_MENU':
			return {
				...state,
				menuIsOpen: true
			}

		case 'CLOSE_MENU':
			return {
				...state,
				menuIsOpen: false
			}

		case 'SET_MENU_OPEN_STATE':
			return {
				...state,
				menuIsOpen: payload
			}

		case 'REQUEST_MENU_DATA':
			return {
				...state,
				isLoadingMenu: true
			}

		case 'RECEIVE_MENU_DATA':
			return {
				...state,
				isLoadingMenu: false,
				menuItems: payload.site_menu,
				menuItemsSecondary: payload.site_menu_secondary
			}

		case 'RECEIVE_SITE_DATA':
			return {
				...state,
				menuItems: payload.site_menu,
				menuItemsSecondary: payload.site_menu_secondary
			}

		case 'RECEIVE_LOCATIONS_DATA':
			locationsCloseToLocation = {}

			if ( state.userLocation && state.userLocation.lat ) {
				locationsCloseToLocation = getLocationsCloseToLocation( payload, state.userLocation.lat, state.userLocation.lng )
			}

			return {
				...state,
				locationsById: payload,
				locationsCloseToLocation: locationsCloseToLocation
			}

		case 'SET_LOCATION':
			locationsCloseToLocation = {}

			if ( payload.lat ) {
				locationsCloseToLocation = getLocationsCloseToLocation( state.locationsById, payload.lat, payload.lng )
			}

			return {
				...state,
				userLocation: payload,
				locationsCloseToLocation: locationsCloseToLocation
			}
	}

	return state
}

function getLocationsCloseToLocation( locationsById, lat, lng ) {
	let locationsCloseToLocation = {},
		matchingIds

	if ( ! locationsById || ! lat || ! lng ) {
		return locationsCloseToLocation
	}

	// Convert to array (to sort), adding distance:
	let locationsArray = Object.keys( locationsById ).map( ( key ) => {
		let station = locationsById[ key ]
		let distance = haversineDistance( lat, lng, station.lat, station.lng )

		return {
			...station,
			id: key,
			'distance': distance
		}
	} )

	// Sort by distance from user location:
	locationsArray.sort( ( a, b ) => {
		if ( a.distance < b.distance ) {
			return -1
		} else if ( a.distance > b.distance ) {
			return 1
		}

		return 0
	} )

	// Limit results number:
	locationsArray = locationsArray.slice( 0, 3 )

	return locationsArray
}

function haversineDistance( lat1, lng1, lat2, lng2 ) {
	let earthRadius = 6371, // KM.
		latDifference = lat2 - lat1,
		latDifferenceRad = toRad( latDifference ),
		lngDifference = lng2 - lng1,
		lngDifferenceRad = toRad( lngDifference )

	let a = Math.sin( latDifferenceRad / 2 ) * Math.sin( latDifferenceRad / 2 ) +
		Math.cos( toRad( lat1 ) ) * Math.cos( toRad( lat2 ) ) *
		Math.sin( lngDifferenceRad / 2 ) * Math.sin( lngDifferenceRad / 2 )

	let c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) )
	let distance = earthRadius * c

	return distance
}

function toRad( x ) {
	return x * Math.PI / 180
}



// WEBPACK FOOTER //
// ./redux/reducers/site.jsx